import React, { FunctionComponent } from "react";
import { theme } from "/src/assets/theme";
import { makeStyles } from "@mui/styles";
import cs from "classnames";

export interface ClubLogoProps {
  size?: ClubLogoSize;
  url?: string;
  className?: string;
  backgroundColor?: string;
  borderColor?: string;
}

export enum ClubLogoSize {
  SMALL,
  NORMAL,
}

export const ClubLogo: FunctionComponent<ClubLogoProps> = ({
  url,
  size = ClubLogoSize.NORMAL,
  backgroundColor = theme.primaryColor,
  borderColor = "transparent",
  className,
}) => {
  const classes = useStyles();

  if (!url) return null;

  return (
    <div
      className={cs(
        classes.avatar,
        size === ClubLogoSize.SMALL ? classes.small : "",
        className
      )}
    >
      <img src={url} className={classes.logo} />
    </div>
  );
};

const useStyles = makeStyles({
  avatar: {
    width: "7.5rem",
    height: "7.5rem",
    background: "white",
    borderColor: theme.primaryColor70,
    padding: "0.3rem",
    border: "1px solid",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    flexShrink: 0,
  },
  small: {
    width: "2rem",
    height: "2rem",
  },
  logo: {
    maxWidth: "80%",
    maxHeight: "80%",
  },
});
